<template><section><h1>group-select 分组选择器</h1>
<p>虽然名义上是分组选择器，但是实际上，也能不分组显示。跟普通下拉选择器的区别是，提供确定/取消按钮，才能最终确定修改结果。</p>
<p>目前只有多选功能。</p>
<p>适用场景：</p>
<p>跟普通下拉选择器（即选即用）相比，这种更适合避免频繁更新对应所选项引发的渲染界面显示不友好或性能不好等问题，等用户选择好之后最终确定才发生更改渲染。</p>
<h2 id="dai-ma-yan-shi"><a class="header-anchor" href="#dai-ma-yan-shi">¶</a> 代码演示</h2>

<h3 id="ji-chu-ying-yong"><a class="header-anchor" href="#ji-chu-ying-yong">¶</a> 基础应用</h3>
<p>实际上不仅仅只能一层分组，还可以多层分组，只要在对应项上添加<code v-pre>children</code>字段即可实现多层分组</p>

      <demo-block class="demo-box" :jsfiddle="{&quot;html&quot;:&quot;&lt;com-group-select :option=\&quot;option1\&quot; v-model=\&quot;selectedData1\&quot;&gt;\n    &lt;span slot=\&quot;reference\&quot;&gt;地域选择&lt;/span&gt;\n&lt;/com-group-select&gt;\n&quot;,&quot;script&quot;:&quot;\n    export default {\n        data () {\n            return {\n                selectedData1: [],\n                option1: [\n                    {\n                        label: '广东省',\n                        value: 'guangdong',\n                        children: [\n                            {\n                                label: '东莞市',\n                                value: 'dongguan'\n                            },\n                            {\n                                label: '广州市',\n                                value: 'guangzhou'\n                            },\n                            {\n                                label: '佛山市',\n                                value: 'foshan'\n                            },\n                            {\n                                label: '清远市',\n                                value: 'qingyuan'\n                            },\n                            {\n                                label: '深圳市',\n                                value: 'shenzhen'\n                            },\n                            {\n                                label: '湛江市',\n                                value: 'zhanjiang'\n                            },\n                            {\n                                label: '惠州市',\n                                value: 'huizhou'\n                            },\n                            {\n                                label: '梅州市',\n                                value: 'meizhou'\n                            },\n                            {\n                                label: '茂名市',\n                                value: 'maoming'\n                            }\n                        ]\n                    },\n                    {\n                        label: '湖北省',\n                        value: 'hubei',\n                        children: [\n                            {\n                                label: '武汉',\n                                value: 'wuhan'\n                            },\n                            {\n                                label: '选项1',\n                                value: 'xuanxiang1'\n                            },\n                            {\n                                label: '选项2',\n                                value: 'xuanxiang2'\n                            },\n                            {\n                                label: '选项3',\n                                value: 'xuanxiang3'\n                            },\n                            {\n                                label: '选项4',\n                                value: 'xuanxiang4'\n                            },\n                            {\n                                label: '选项5',\n                                value: 'xuanxiang5'\n                            },\n                            {\n                                label: '选项6',\n                                value: 'xuanxiang6'\n                            },\n                            {\n                                label: '选项7',\n                                value: 'xuanxiang7'\n                            },\n                            {\n                                label: '选项8',\n                                value: 'xuanxiang8'\n                            },\n                            {\n                                label: '选项9',\n                                value: 'xuanxiang'\n                            }\n                        ]\n                    }\n                ],\n                selectedData2: [],\n                option2: [\n                    {\n                        label: '广东省',\n                        value: 'guangdong'\n                    },\n                    {\n                        label: '湖北省',\n                        value: 'hubei'\n                    }\n                ]\n            };\n        }\n    };\n\n&quot;,&quot;style&quot;:null}">
        <div class="source" slot="source"><com-group-select :option="option1" v-model="selectedData1">
    <span slot="reference">地域选择</span>
</com-group-select>
</div>
        
        <div class="hljs highlight" slot="highlight">
    <pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">com-group-select</span> <span class="hljs-attr">:option</span>=<span class="hljs-string">"option1"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"selectedData1"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"reference"</span>&gt;</span>地域选择<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">com-group-select</span>&gt;</span>
</code></pre>
<pre v-pre><code v-pre class="language-js">&lt;script&gt;
    <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
        data () {
            <span class="hljs-keyword">return</span> {
                <span class="hljs-attr">selectedData1</span>: [],
                <span class="hljs-attr">option1</span>: [
                    {
                        <span class="hljs-attr">label</span>: <span class="hljs-string">'广东省'</span>,
                        <span class="hljs-attr">value</span>: <span class="hljs-string">'guangdong'</span>,
                        <span class="hljs-attr">children</span>: [
                            {
                                <span class="hljs-attr">label</span>: <span class="hljs-string">'东莞市'</span>,
                                <span class="hljs-attr">value</span>: <span class="hljs-string">'dongguan'</span>
                            },
                            {
                                <span class="hljs-attr">label</span>: <span class="hljs-string">'广州市'</span>,
                                <span class="hljs-attr">value</span>: <span class="hljs-string">'guangzhou'</span>
                            },
                            {
                                <span class="hljs-attr">label</span>: <span class="hljs-string">'佛山市'</span>,
                                <span class="hljs-attr">value</span>: <span class="hljs-string">'foshan'</span>
                            },
                            {
                                <span class="hljs-attr">label</span>: <span class="hljs-string">'清远市'</span>,
                                <span class="hljs-attr">value</span>: <span class="hljs-string">'qingyuan'</span>
                            },
                            {
                                <span class="hljs-attr">label</span>: <span class="hljs-string">'深圳市'</span>,
                                <span class="hljs-attr">value</span>: <span class="hljs-string">'shenzhen'</span>
                            },
                            {
                                <span class="hljs-attr">label</span>: <span class="hljs-string">'湛江市'</span>,
                                <span class="hljs-attr">value</span>: <span class="hljs-string">'zhanjiang'</span>
                            },
                            {
                                <span class="hljs-attr">label</span>: <span class="hljs-string">'惠州市'</span>,
                                <span class="hljs-attr">value</span>: <span class="hljs-string">'huizhou'</span>
                            },
                            {
                                <span class="hljs-attr">label</span>: <span class="hljs-string">'梅州市'</span>,
                                <span class="hljs-attr">value</span>: <span class="hljs-string">'meizhou'</span>
                            },
                            {
                                <span class="hljs-attr">label</span>: <span class="hljs-string">'茂名市'</span>,
                                <span class="hljs-attr">value</span>: <span class="hljs-string">'maoming'</span>
                            }
                        ]
                    },
                    {
                        <span class="hljs-attr">label</span>: <span class="hljs-string">'湖北省'</span>,
                        <span class="hljs-attr">value</span>: <span class="hljs-string">'hubei'</span>,
                        <span class="hljs-attr">children</span>: [
                            {
                                <span class="hljs-attr">label</span>: <span class="hljs-string">'武汉'</span>,
                                <span class="hljs-attr">value</span>: <span class="hljs-string">'wuhan'</span>
                            },
                            {
                                <span class="hljs-attr">label</span>: <span class="hljs-string">'选项1'</span>,
                                <span class="hljs-attr">value</span>: <span class="hljs-string">'xuanxiang1'</span>
                            },
                            {
                                <span class="hljs-attr">label</span>: <span class="hljs-string">'选项2'</span>,
                                <span class="hljs-attr">value</span>: <span class="hljs-string">'xuanxiang2'</span>
                            },
                            {
                                <span class="hljs-attr">label</span>: <span class="hljs-string">'选项3'</span>,
                                <span class="hljs-attr">value</span>: <span class="hljs-string">'xuanxiang3'</span>
                            },
                            {
                                <span class="hljs-attr">label</span>: <span class="hljs-string">'选项4'</span>,
                                <span class="hljs-attr">value</span>: <span class="hljs-string">'xuanxiang4'</span>
                            },
                            {
                                <span class="hljs-attr">label</span>: <span class="hljs-string">'选项5'</span>,
                                <span class="hljs-attr">value</span>: <span class="hljs-string">'xuanxiang5'</span>
                            },
                            {
                                <span class="hljs-attr">label</span>: <span class="hljs-string">'选项6'</span>,
                                <span class="hljs-attr">value</span>: <span class="hljs-string">'xuanxiang6'</span>
                            },
                            {
                                <span class="hljs-attr">label</span>: <span class="hljs-string">'选项7'</span>,
                                <span class="hljs-attr">value</span>: <span class="hljs-string">'xuanxiang7'</span>
                            },
                            {
                                <span class="hljs-attr">label</span>: <span class="hljs-string">'选项8'</span>,
                                <span class="hljs-attr">value</span>: <span class="hljs-string">'xuanxiang8'</span>
                            },
                            {
                                <span class="hljs-attr">label</span>: <span class="hljs-string">'选项9'</span>,
                                <span class="hljs-attr">value</span>: <span class="hljs-string">'xuanxiang'</span>
                            }
                        ]
                    }
                ],
                <span class="hljs-attr">selectedData2</span>: [],
                <span class="hljs-attr">option2</span>: [
                    {
                        <span class="hljs-attr">label</span>: <span class="hljs-string">'广东省'</span>,
                        <span class="hljs-attr">value</span>: <span class="hljs-string">'guangdong'</span>
                    },
                    {
                        <span class="hljs-attr">label</span>: <span class="hljs-string">'湖北省'</span>,
                        <span class="hljs-attr">value</span>: <span class="hljs-string">'hubei'</span>
                    }
                ]
            };
        }
    };

&lt;<span class="hljs-regexp">/script&gt;
</span></code></pre>
</div></demo-block>
<h3 id="ye-ke-yi-yong-zuo-yi-zu-xuan-ze-qi-ji-bu-fen-zu-shi-yong"><a class="header-anchor" href="#ye-ke-yi-yong-zuo-yi-zu-xuan-ze-qi-ji-bu-fen-zu-shi-yong">¶</a> 也可以用作一组选择器，即不分组使用</h3>

      <demo-block class="demo-box" :jsfiddle="{&quot;html&quot;:&quot;&lt;com-group-select :option=\&quot;option2\&quot; v-model=\&quot;selectedData2\&quot;&gt;\n    &lt;span slot=\&quot;reference\&quot;&gt;地域选择&lt;/span&gt;\n&lt;/com-group-select&gt;\n&quot;,&quot;script&quot;:&quot;\n    export default {\n        data () {\n            return {\n                selectedData2: [],\n                option2: [\n                    {\n                        label: '广东省',\n                        value: 'guangdong'\n                    },\n                    {\n                        label: '湖北省',\n                        value: 'hubei'\n                    }\n                ]\n            };\n        }\n    };\n    \n&quot;,&quot;style&quot;:null}">
        <div class="source" slot="source"><com-group-select :option="option2" v-model="selectedData2">
    <span slot="reference">地域选择</span>
</com-group-select>
</div>
        
        <div class="hljs highlight" slot="highlight">
    <pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">com-group-select</span> <span class="hljs-attr">:option</span>=<span class="hljs-string">"option2"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"selectedData2"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"reference"</span>&gt;</span>地域选择<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">com-group-select</span>&gt;</span>
</code></pre>
<pre v-pre><code v-pre class="language-js">&lt;script&gt;
    <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
        data () {
            <span class="hljs-keyword">return</span> {
                <span class="hljs-attr">selectedData2</span>: [],
                <span class="hljs-attr">option2</span>: [
                    {
                        <span class="hljs-attr">label</span>: <span class="hljs-string">'广东省'</span>,
                        <span class="hljs-attr">value</span>: <span class="hljs-string">'guangdong'</span>
                    },
                    {
                        <span class="hljs-attr">label</span>: <span class="hljs-string">'湖北省'</span>,
                        <span class="hljs-attr">value</span>: <span class="hljs-string">'hubei'</span>
                    }
                ]
            };
        }
    };
    
&lt;<span class="hljs-regexp">/script&gt;
</span></code></pre>
</div></demo-block>
<h3 id="zi-ding-yi-pei-zhi-xiang-ming-cheng"><a class="header-anchor" href="#zi-ding-yi-pei-zhi-xiang-ming-cheng">¶</a> 自定义配置项名称</h3>
<p>多层分组同样也是这么使用</p>

      <demo-block class="demo-box" :jsfiddle="{&quot;html&quot;:&quot;&lt;com-group-select :option=\&quot;option3\&quot; v-model=\&quot;selectedData3\&quot; :prop=\&quot;customProp\&quot;&gt;\n    &lt;span slot=\&quot;reference\&quot;&gt;地域选择&lt;/span&gt;\n&lt;/com-group-select&gt;\n&quot;,&quot;script&quot;:&quot;\n    export default {\n        data () {\n            return {\n                selectedData3: [],\n                option3: [\n                    {\n                        name: '广东省',\n                        type: 'guangdong',\n                        canuse: true\n                    },\n                    {\n                        name: '湖北省',\n                        type: 'hubei'\n                    }\n                ],\n                customProp: {\n                    label: 'name',\n                    value: 'type',\n                    disabled: 'canuse'\n                }\n            };\n        }\n    };\n    \n&quot;,&quot;style&quot;:null}">
        <div class="source" slot="source"><com-group-select :option="option3" v-model="selectedData3" :prop="customProp">
    <span slot="reference">地域选择</span>
</com-group-select>
</div>
        
        <div class="hljs highlight" slot="highlight">
    <pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">com-group-select</span> 
    <span class="hljs-attr">:option</span>=<span class="hljs-string">"option3"</span> 
    <span class="hljs-attr">v-model</span>=<span class="hljs-string">"selectedData3"</span> 
    <span class="hljs-attr">:prop</span>=<span class="hljs-string">"customProp"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"reference"</span>&gt;</span>地域选择<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">com-group-select</span>&gt;</span>
</code></pre>
<pre v-pre><code v-pre class="language-js">&lt;script&gt;
    <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
        data () {
            <span class="hljs-keyword">return</span> {
                <span class="hljs-attr">selectedData3</span>: [],
                <span class="hljs-attr">option3</span>: [
                    {
                        <span class="hljs-attr">name</span>: <span class="hljs-string">'广东省'</span>,
                        <span class="hljs-attr">type</span>: <span class="hljs-string">'guangdong'</span>,
                        <span class="hljs-attr">canuse</span>: <span class="hljs-literal">true</span>
                    },
                    {
                        <span class="hljs-attr">name</span>: <span class="hljs-string">'湖北省'</span>,
                        <span class="hljs-attr">type</span>: <span class="hljs-string">'hubei'</span>
                    }
                ],
                <span class="hljs-attr">customProp</span>: {
                    <span class="hljs-attr">label</span>: <span class="hljs-string">'name'</span>,
                    <span class="hljs-attr">value</span>: <span class="hljs-string">'type'</span>,
                    <span class="hljs-attr">disabled</span>: <span class="hljs-string">'canuse'</span>
                }
            };
        }
    };
    
&lt;<span class="hljs-regexp">/script&gt;
</span></code></pre>
</div></demo-block>
<h3 id="mo-ren-xuan-ze"><a class="header-anchor" href="#mo-ren-xuan-ze">¶</a> 默认选择</h3>
<p>可以直接通过value值来控制选中的项。</p>
<p>disabled字段为禁用。</p>

      <demo-block class="demo-box" :jsfiddle="{&quot;html&quot;:&quot;&lt;com-group-select :option=\&quot;option4\&quot; v-model=\&quot;selectedData4\&quot;&gt;\n    &lt;span slot=\&quot;reference\&quot;&gt;地域选择&lt;/span&gt;\n&lt;/com-group-select&gt;\n&quot;,&quot;script&quot;:&quot;\n    export default {\n        data () {\n            return {\n                selectedData4: ['guangdong', 'beijing'],\n                option4: [\n                    {\n                        label: '广东省',\n                        value: 'guangdong'\n                    },\n                    {\n                        label: '湖北省',\n                        value: 'hubei'\n                    },\n                    {\n                        label: '北京市',\n                        value: 'beijing',\n                        disabled: true\n                    }\n                ]\n            };\n        }\n    };\n    \n&quot;,&quot;style&quot;:null}">
        <div class="source" slot="source"><com-group-select :option="option4" v-model="selectedData4">
    <span slot="reference">地域选择</span>
</com-group-select>
</div>
        
        <div class="hljs highlight" slot="highlight">
    <pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">com-group-select</span> <span class="hljs-attr">:option</span>=<span class="hljs-string">"option4"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"selectedData4"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"reference"</span>&gt;</span>地域选择<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">com-group-select</span>&gt;</span>
</code></pre>
<pre v-pre><code v-pre class="language-js">&lt;script&gt;
    <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
        data () {
            <span class="hljs-keyword">return</span> {
                <span class="hljs-attr">selectedData4</span>: [<span class="hljs-string">'guangdong'</span>, <span class="hljs-string">'beijing'</span>],
                <span class="hljs-attr">option4</span>: [
                    {
                        <span class="hljs-attr">label</span>: <span class="hljs-string">'广东省'</span>,
                        <span class="hljs-attr">value</span>: <span class="hljs-string">'guangdong'</span>
                    },
                    {
                        <span class="hljs-attr">label</span>: <span class="hljs-string">'湖北省'</span>,
                        <span class="hljs-attr">value</span>: <span class="hljs-string">'hubei'</span>
                    },
                    {
                        <span class="hljs-attr">label</span>: <span class="hljs-string">'北京市'</span>,
                        <span class="hljs-attr">value</span>: <span class="hljs-string">'beijing'</span>,
                        <span class="hljs-attr">disabled</span>: <span class="hljs-literal">true</span>
                    }
                ]
            };
        }
    };
    
&lt;<span class="hljs-regexp">/script&gt;
</span></code></pre>
</div></demo-block>
<h3 id="props"><a class="header-anchor" href="#props">¶</a> Props</h3>
<table class="table"><thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
<th>是否必填</th>
</tr>
</thead>
<tbody>
<tr>
<td>value</td>
<td>选择的值，可用<code v-pre>v-model</code></td>
<td>Array</td>
<td>—</td>
<td>—</td>
<td>no</td>
</tr>
<tr>
<td>option</td>
<td>选项配置，选项设置默认是<code v-pre>{label: '', value: null, disabled: false}</code>的格式</td>
<td>Array</td>
<td>—</td>
<td>—</td>
<td>yes</td>
</tr>
<tr>
<td>prop</td>
<td>改写选项配置的三个默认字段名</td>
<td>Object</td>
<td>—</td>
<td>—</td>
<td>no</td>
</tr>
<tr>
<td>width</td>
<td>选择器的宽度</td>
<td>String, Number。 传入数字类型时，单位是<code v-pre>px</code></td>
<td>—</td>
<td>—</td>
<td>no</td>
</tr>
</tbody>
</table>
<h3 id="events"><a class="header-anchor" href="#events">¶</a> events</h3>
<table class="table"><thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>改变选择值</td>
<td>新值</td>
</tr>
</tbody>
</table>
</section></template>

<script>
    export default {
        data () {
            return {
                selectedData1: [],
                option1: [
                    {
                        label: '广东省',
                        value: 'guangdong',
                        children: [
                            {
                                label: '东莞市',
                                value: 'dongguan'
                            },
                            {
                                label: '广州市',
                                value: 'guangzhou'
                            },
                            {
                                label: '佛山市',
                                value: 'foshan'
                            },
                            {
                                label: '清远市',
                                value: 'qingyuan'
                            },
                            {
                                label: '深圳市',
                                value: 'shenzhen'
                            },
                            {
                                label: '湛江市',
                                value: 'zhanjiang'
                            },
                            {
                                label: '惠州市',
                                value: 'huizhou'
                            },
                            {
                                label: '梅州市',
                                value: 'meizhou'
                            },
                            {
                                label: '茂名市',
                                value: 'maoming'
                            }
                        ]
                    },
                    {
                        label: '湖北省',
                        value: 'hubei',
                        children: [
                            {
                                label: '武汉',
                                value: 'wuhan'
                            },
                            {
                                label: '选项1',
                                value: 'xuanxiang1'
                            },
                            {
                                label: '选项2',
                                value: 'xuanxiang2'
                            },
                            {
                                label: '选项3',
                                value: 'xuanxiang3'
                            },
                            {
                                label: '选项4',
                                value: 'xuanxiang4'
                            },
                            {
                                label: '选项5',
                                value: 'xuanxiang5'
                            },
                            {
                                label: '选项6',
                                value: 'xuanxiang6'
                            },
                            {
                                label: '选项7',
                                value: 'xuanxiang7'
                            },
                            {
                                label: '选项8',
                                value: 'xuanxiang8'
                            },
                            {
                                label: '选项9',
                                value: 'xuanxiang'
                            }
                        ]
                    }
                ],
                selectedData2: [],
                option2: [
                    {
                        label: '广东省',
                        value: 'guangdong'
                    },
                    {
                        label: '湖北省',
                        value: 'hubei'
                    }
                ],
                selectedData3: [],
                option3: [
                    {
                        name: '广东省',
                        type: 'guangdong',
                        canuse: true
                    },
                    {
                        name: '湖北省',
                        type: 'hubei'
                    }
                ],
                customProp: {
                    label: 'name',
                    value: 'type',
                    disabled: 'canuse'
                },
                selectedData4: ['guangdong', 'beijing'],
                option4: [
                    {
                        label: '广东省',
                        value: 'guangdong'
                    },
                    {
                        label: '湖北省',
                        value: 'hubei'
                    },
                    {
                        label: '北京市',
                        value: 'beijing',
                        disabled: true
                    }
                ]
            };
        }
    };

</script>